import React from "react";
import { connect } from "react-redux";
import {
  URL,
  getAuthorizationHeader,
  idEmpresa,
  getAuthorizationHeaderUpload,
} from "../../constans/constants";
import { exportarDocumento } from "../lotes/LoteService";
import axios from "axios";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import { logout } from "../login/SesionService"
import { getUsuario } from "../usuario/UsuarioService";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import DropzoneComponent from "../componentes/DropzoneComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import { validateForm } from "../../constans/validationUtils";
import {
  mostrarErroresEnFormulario, configurarLimpiezaAutomatica,
  integrarConHandleInput, limpiarErrorCampo
} from '../../constans/form-error-utils';

class ImportarDocumentoGrupos extends React.Component {
  constructor(props) {
    super(props);
    var today = new Date(),
      date =
        today.getDate() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getFullYear();

    const originalHandleInput = this.handleInput;

    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      descripcion: "",
      numeroPatronal: [],
      gruposUsuarios: [],
      tipoDocumento: [],
      lote: [],
      id: "",
      date: date,
      archivoLote: null,
      uploadDisabled: false,
      numeroPatronalID: "",
      tipoDocumentoID: "",
      formatoTipoDocumentoSeleccionado: "",
      idGrupo: "",
      isCarpetaPorDefecto: false,
      carpetaPorDefecto: "",
      fileErrorMsg: "",
      path: "",
      mensaje: "",
      severity: "",
      mostrarMensajeFlash: false,
      submit: false,
      openPantallaCarga: false,
      validated: false,
      requiredNroMtess: false,
      openPantallaCarga: false,
      listaArchivosPermitidos: ['xml', 'pdf'],
    };
  }

  reglasValidacionCampos = {
    descripcion: [
      { required: true, message: 'Debe proveer una descripcion para el lote' },
      {
        customValidator: (value, formData) => {
          return value.length < 251
        }, message: 'La cantidad maxima de caracteres es de 250'
      }
    ],
    tipoDocumentoID: [
      {
        customValidator: (value, formData) => {
          return value > 0
        }, message: 'Debe seleccionar un tipo de documento'
      },
    ],
    numeroPatronalID: [
      {
        customValidator: (value, formData) => {
          if (!this.validarExtensionDocumento())
            return true
          else
            return value > 0
        }, message: 'Debe elegir una opcion'
      },
    ],
    carpetaPorDefecto: [
      {
        customValidator: (value, formData) => {
          if (!this.state.isCarpetaPorDefecto)
            return true
          else
            return /^(\/[^\/]+)+$/.test(value)
        }, message: 'Ingrese una direccion valida'
      },
    ],
    idGrupo: [
      {
        customValidator: (value, formData) => {
          return value > 0
        }, message: 'Debe seleccionar un grupo'
      }
    ],
    archivoLote: [
      { required: true, message: 'Debe cargar un documento' },
      {
        allowedExtensions: (formData) => {
          let extensions = formData.listaArchivosPermitidos;
          return extensions;
        },
        message: 'Archivo no permitido según tipo documento elegido'
      },
      {
        allowedMimeTypes: (formData) => {
          const formatoSeleccionado = formData.formatoTipoDocumentoSeleccionado.toLowerCase();
          if (formatoSeleccionado === 'xml') {
            return ['application/xml'];
          }
          if (formatoSeleccionado === 'pdf') {
            return ['application/pdf'];
          }
          return [];
        },
        message: 'Tipo de archivo no permitido'
      }
    ]
  }

  handleChange = (event) => {
    this.setState({ ...this.state, [event.target.name]: event.target.checked });
  };

  handleDialogImport = (value) => {
    this.setState({
      resultImportPopUp: value
    })
  }

  handleChecked = (event) => {
    const name = event.target.name;
    const val = event.target.checked;
    this.setState({
      [name]: val,
      idGrupo: ""
    });
  }

  subirArchivo = event => {
    event.preventDefault();
    const { isValid, errors } = validateForm(this.state, this.reglasValidacionCampos);
    if (isValid) {
      mostrarErroresEnFormulario({});
      const data = {
        description: this.state.descripcion,
        file: null,
        filename: this.state.nombreArchivo,
        empresaId: idEmpresa(),
        idGrupo: this.state.idGrupo,
        numeroPatronalId: this.state.numeroPatronalID,
        documentTypeId: this.state.tipoDocumentoID,
        serverFolder: this.state.carpetaPorDefecto,
      }
      if (this.state.uploadDisabled) {
        this.setState({ openPantallaCarga: true });
        axios
          .post(URL + "lote/import/form/server", data, getAuthorizationHeader())
          .then((res) => {
            this.manejarResultadoSubidaArchivos(res.data)
          }, error => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          });
      } else {

        this.setState({ openPantallaCarga: true });
        let formData = new FormData();
        formData.append("file", this.state.archivoLote);
        axios
          .post(URL + "recibo/upload/pdf", formData, getAuthorizationHeaderUpload())
          .then((res) => {
            if (res.data.error == false) {
              data.file = res.data.datos;
              axios
                .post(URL + "recibo/importarDocumento", data, getAuthorizationHeader())
                .then((res) => {
                  this.manejarResultadoSubidaArchivos(res.data)
                }, error => {
                  if (error.response.status === 401) {
                    logout();
                  }
                  return error;
                });
            }
          });
        axios
          .get(
            URL  + "grupos/empresa/" + idEmpresa() + "/getAll",
            getAuthorizationHeader()
          )
          .then((res) => {
            if (res.data.error == false) {
              this.setState({ gruposUsuarios: res.data.datos });
            }
          }, error => {
            if (error.response.status === 401) {
              logout();
            }
            return error;
          });
      }
    } else {
      this.setState({ errors: errors, showErrors: true });
      mostrarErroresEnFormulario(errors);
    }
  };


  componentDidMount() {
    configurarLimpiezaAutomatica()
    axios
      .get(
        URL + "tipoDocumento/listar/" + idEmpresa(),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ tipoDocumento: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    axios
      .get(
        URL + "numeroPatronal/listar/" + idEmpresa(),
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ numeroPatronal: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
    axios
      .get(
        URL + "grupos/empresa/" + idEmpresa() + "/getAll",
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ gruposUsuarios: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
  }

  manejarResultadoSubidaArchivos = (resultado) => {
    this.setState({ openPantallaCarga: false })
    let grupo = this.state.gruposUsuarios?.[0];
    let descripcion = grupo?.descripcion ?? "";
    let resultados = {}
    if (resultado.error) {
      resultados = {
        nombreDocumento: this.state.descripcion,
        destinatario: descripcion,
        errorDetalle: [],
        backURL: this.props.location.pathname,
        urlSiguiente: this.props.location.pathname,
      };
      resultados.errorDetalle.push(resultado.mensaje)
      this.props.history.push({
        pathname: '/documento/import/error',
        state: resultados
      });
    } else {
      let datosImportacion = resultado.datos
      this.props.history.push({
        pathname: '/documento/import/exito',
        state: {
          nombreDocumento: this.state.descripcion,
          destinatario: descripcion,
          errorDetalle: datosImportacion.errors,
          backURL: this.props.location.pathname,
          urlSiguiente: '/lote/recibos/nuevo/' + datosImportacion.batchId
        }
      })
    }

  }

  validarExtensionDocumento = () => {
    let datos = this.state.tipoDocumento;
    let extension = datos.find(tipo => tipo.id == this.state.tipoDocumentoID)
    if (extension) {
      if (extension.formato == "XML") {
        return true
      } else {
        return false
      }
    }
    return false
  }

  formatFileSize = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(decimals)) + sizes[i];
  }

  handleArchivo = (archivo) => {
    if (!this.state.tipoDocumentoID) {
      this.setState(prevState => ({
        errors: {
          ...prevState.errors,
          tipoDocumentoID: "Debe seleccionar un tipo de documento primero"
        }
      }))
      mostrarErroresEnFormulario(this.state.errors)
    } else {
      this.setState({ archivoLote: archivo, nombreArchivo: archivo.name, pesoArchivoMb: this.formatFileSize(archivo.size) })
      limpiarErrorCampo("archivoLote")
    }
  }

  handleInput = (e) => {
    var name = e.target.name;
    var val = e.target.value;
    this.setState({
      [name]: val,
    });
  };

  handleChangeSelect = (e) => {
    const name = e.target.name;
    const val = e.target.value;
    let documento = this.state.tipoDocumento.find(element => element.id == val);
    if (documento)
      this.setState({
        [name]: val,
        formatoTipoDocumentoSeleccionado: documento.formato,
        isCarpetaPorDefecto: documento.carpetaPorDefecto != "" ? true : false,
        carpetaPorDefecto: documento.carpetaPorDefecto,
        uploadDisabled: documento.carpetaPorDefecto != "" ? true : false
      })
  }

  render() {
    return (
      <div className="template-base">
        <header className="component-header">
          <div className="page-container">

            <BreadCrumComponent
              backUrl='/lotes/generar'
              breadcrumbs={
                [
                  { label: 'Nuevo Lote', path: '/lotes/generar' },
                  { label: 'Importar Documento a grupo', path: '' }
                ]
              }
            />
            <div className="head-area">
              <div className="caption-area">
                <h1 className="page-title"> Importar Documento a grupo </h1>
                <p className="page-description"> Complete el siguiente formulario con los datos correspondientes </p>
              </div>
            </div>
          </div>
        </header>
        <div className="wrapperContent">
          <div className="component-form">
            <div className="page-container">

              <div className="component-content card">
                <form onSubmit={this.subirArchivo} className="form container-sm">
                  <h4 className="section__subtitle center-text"> Cargar nuevo documento </h4>
                  <p className="section__description center-text"> Selecciona el documento a cargar en formato pdf </p>

                  <div className="carga-documento-section" name='archivoLote'>
                    <div className="carga-documento-content">
                      <DropzoneComponent onFileSelected={this.handleArchivo} archivos_soportados={["pdf"]} />
                    </div>
                  </div>
                  {
                    this.state.nombreArchivo &&
                    <div className="component-progress-upload">
                      <div className="contentInner">

                        <div className="icon-shape shape-xl">
                          <span className="material-symbols-outlined"> folder_zip </span>
                        </div>
                        <div className="progress-content">
                          <div className="load-info">
                            <span className="file-name">{this.state.nombreArchivo}</span>
                          </div>
                          <div className="file-info">
                            <span className="file-size">{this.state.pesoArchivoMb}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className="form-group__inline">
                    <div className="form-group">
                      <input type="text" name="descripcion" onChange={this.handleInput} className="form-input" placeholder="" value={this.state.descripcion} />
                      <label htmlFor="text" className="form-label"> Descripción </label>
                    </div>
                    <div className="form-group">
                      <select className="form-select" name="tipoDocumentoID" onChange={this.handleChangeSelect} value={this.state.tipoDocumentoID}>
                        <option value=""> </option>
                        {this.state.tipoDocumento.map((elemento) => (
                          <option key={elemento.id} value={elemento.id}>
                            {elemento.nombre}
                          </option>
                        ))}
                      </select>
                      <label className="form-label"> Tipo de documento </label>
                    </div>
                    {
                      this.state.isCarpetaPorDefecto &&
                      <div className="form-group">
                        <input type="text" name="carpetaPorDefecto" onChange={this.handleInput} className="form-input" placeholder="" value={this.state.carpetaPorDefecto} />
                        <label htmlFor="text" className="form-label"> Carpeta por defecto </label>
                      </div>
                    }

                    {
                      this.validarExtensionDocumento() &&
                      <div className="form-group">
                        <select className="form-select" name="numeroPatronalID" onChange={this.handleInput} value={this.state.numeroPatronalID}>
                          <option key="" value="" selected></option>
                          {this.state.numeroPatronal.map((elemento) => (
                            <option value={elemento.id} key={elemento.id}>{elemento.nombre}</option>
                          ))}
                        </select>
                        <label className="form-label"> Nro. MTESS patronal </label>
                      </div>
                    }

                    <div className="form-group">
                      <select className="form-select" name="idGrupo" onChange={this.handleInput} value={this.state.idGrupo}>
                        <option value=""> </option>
                        {this.state.gruposUsuarios.map((elemento) => (
                          <option value={elemento.idGrupo} key={elemento.idGrupo}>{elemento.descripcion}</option>
                        ))}
                      </select>
                      <label className="form-label"> Seleccione un grupo de usuarios </label>
                    </div>
                  </div>
                  <div className="form-actions">
                    <button onClick={() => this.props.history.push('/lotes/generar')} className="btn-medium btn-link"> Cancelar </button>
                    <button type="submit" className="btn-medium btn-primary"> Continuar </button>
                  </div>
                </form>
              </div>

            </div>
            <MensajeFlash
              visible={this.state.mostrarMensajeFlash}
              mensaje={this.state.mensajeFlash}
              severity={this.state.mensajeFlashSeverity} />
          </div>
          <PantallaCarga open={this.state.openPantallaCarga} />
        </div>
      </div>
    );

  }

}

const mapDispatchToProps = (dispatch) => ({
  exportarDocumento: (file) => dispatch(exportarDocumento(file)),
  getUsuario: (page, size, search) => dispatch(getUsuario(page, size, search))
});

const mapStateToProps = (state) => ({
  usuariosData: state.usuariosData,
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportarDocumentoGrupos);